module.exports = __webpack_public_path__ + "static/img/trade1.1b5019f0.png";